import { getAuthHeader } from "./authService";

const BASE_URL = `${process.env.REACT_APP_BACKEND_URL}/api/v1/posiciones`;

const toJson = (res) => res.json().catch(() => ({}));
const ensureOk = (res, data) => {
  if (!res.ok) {
    const msg =
      data?.message ||
      data?.error ||
      (typeof data === "string" ? data : "") ||
      `HTTP ${res.status}`;
    throw new Error(msg);
  }
};
/* const clean = (obj) => {
  const out = {};
  Object.entries(obj || {}).forEach(([k, v]) => {
    if (v === undefined || v === null) return;
    if (typeof v === "string" && v.trim() === "") return;
    out[k] = v;
  });
  return out;
}; */

/**
 * GET — listar posiciones
 * http://localhost:3000/api/v1/posiciones
 */
export async function listPosiciones() {
  const response = await fetch(`${BASE_URL}`, {
    headers: { Accept: "application/json", ...getAuthHeader() },
  });
  const data = await toJson(response);
  ensureOk(response, data);

  return Array.isArray(data) ? data : data?.data ?? [];
}
